import { render, staticRenderFns } from "./PagamentoTimeLine.vue?vue&type=template&id=9ca37b8e"
import script from "./PagamentoTimeLine.vue?vue&type=script&lang=js"
export * from "./PagamentoTimeLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports